import { defineMessages } from 'react-intl';

export const QeReader = defineMessages({
  selectCamera: {
    id: 'app.common.selectCamera',
    defaultMessage: 'Vyber kameru',
  },
});
